/* assets/shipping-protection.js — tiered Shipping Protection auto-add (STABLE v6.2.6, 2026-10-22)
 * Product 9182262952092 ("Shipping Protection"). Price ladder:
 * $0-$49=$1.49; $50-$149=$2.99; $150-$299=$4.99; $300-$599=$6.97;
 * $600-$999=$8.47; $1000-$1249=$11.99; $1250+=$14.99.
 *
 * v6: rewritten to STOP the cart fight. Strict rules:
 *  1. At most ONE exchange per sync (add, swap, dedupe, or remove) — the tier swap
 *     is an atomic /cart/update.js key swap (old key 0 + new variant id 1) — never chains of remove-all/re-add.
 *  2. Never re-orders merchandise lines. Protection stays wherever Shopify puts it.
 *  3. Self-mutation guard: the sync's own fetches never re-trigger sync.
 *  4. Cooldown: after any write, ignore events for 3s; after any correction
 *     wait 1.5s so the theme finishes rendering before re-reading.
 *  5. A passive fetch wrapper only READS after mutations; it never chains
 *     extra work onto responses or delays theme rendering.
 * v6.2: protection forced LAST in cart. Since /cart/add.js inserts at the FRONT on
 * these stores, a bounded one-pass move re-adds merchandise (reverse order) after
 * protection, so checkout shows: [merchandise..., Shipping Protection]. Never
 * removes protection mid-move, max 2 attempts, cooldown-guarded. */
(function () {
  'use strict';
  var PRODUCT_ID = '9182262952092';
  var AUTO_ADD = true;
  /* v6.2.2: never touch carts containing these products. Their checkout flows
   * auto-add companion lines (e.g. Petal Ultrasonic Combo -> Petal Pods); our
   * reposition/re-add churn breaks those adds. For these carts protection is
   * fully skipped (no add, no reposition, no writes at all). */
  var EXCLUDED_PRODUCTS = [];
  /* v6.2.5 US: combo carts (Petal Ultrasonic/Whitening) GET insurance again, but
   * are NEVER repositioned — the reposition remove/re-add churn broke the
   * combo -> Pods companion add. No churn = Pods flow is untouched. */
  var EXCLUDE_REPOSITION = ["8266345447580", "8289158660252", "5311245877404", "6118084411548"];
  try {
    var el = document.querySelector('[data-shipping-protection]');
    if (el && el.getAttribute('data-shipping-protection') === 'off') AUTO_ADD = false;
    if (document.querySelector('[data-shipping-protection-optin]')) AUTO_ADD = true;
  } catch (e) {}
  var TIERS = [
    { min: 0.00, max: 49.99, variantId: 47282428084380 },
    { min: 50.00, max: 149.99, variantId: 47282428117148 },
    { min: 150.00, max: 299.99, variantId: 47282428149916 },
    { min: 300.00, max: 599.99, variantId: 47282428182684 },
    { min: 600.00, max: 999.99, variantId: 47282428215452 },
    { min: 1000.00, max: 1249.99, variantId: 47787221024924 },
    { min: 1250.00, max: Infinity, variantId: 47787221090460 }
  ];
  function tierFor(subtotal) {
    for (var i = 0; i < TIERS.length; i++) {
      if (subtotal >= TIERS[i].min && subtotal <= TIERS[i].max) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }
  function lineAmount(it) { return (it.final_line_price != null ? it.final_line_price : it.line_price) / 100; }
  var nativeFetch = (window.fetch && window.fetch.bind(window)) || null;
  var selfMutation = false, busy = false, cooldownUntil = 0;
  function cool(ms) { cooldownUntil = Date.now() + ms; }
  function inCool() { return Date.now() < cooldownUntil; }
  function inCheckout() {
    try { return /\/checkout(\/|$)/i.test(window.location.pathname); } catch (e) { return false; }
  }
  function raw(url, opts) {
    var f = window.fetch, args = Array.prototype.slice.call(arguments);
    selfMutation = true;
    try { return f.apply(window, args); }
    finally { selfMutation = false; }
  }
  function getCart() {
    return raw('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function hasNoReposition(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (EXCLUDE_REPOSITION.indexOf(String(items[i].product_id)) !== -1) return true;
    }
    return false;
  }
  function settledState(cart) {
    // returns: 'settled' | 'empty' | 'add' | 'change' | 'remove'
    var items = (cart && cart.items) || [];
    var merch = 0, prot = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.product_id) === PRODUCT_ID) prot.push(it);
      else merch += lineAmount(it);
    }
    if (!items.length || merch <= 0) return prot.length ? 'remove' : 'settled';
    var want = String(tierFor(merch).variantId);
    if (!prot.length) return AUTO_ADD ? 'add' : 'settled';
    if (prot.length > 1) return 'change';
    if (String(prot[0].variant_id) !== want) return 'change';
    if (items.length > 1 && items[items.length - 1] !== prot[0] && !hasNoReposition(cart)) return 'reposition';
    return 'settled';
  }
  function repositionLast(cart) {
    // Put protection LAST without a full-cart rebuild: merchandise display order is
    // preserved by re-adding it in reverse (front-insert store). One remove call +
    // re-adds; protection never leaves the cart mid-move.
    var items = (cart && cart.items) || [];
    var merch = [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].product_id) !== PRODUCT_ID) merch.push(items[i]);
    }
    if (!merch.length) return Promise.resolve('done');
    var zero = {};
    for (var m = 0; m < merch.length; m++) zero[merch[m].key] = 0;
    var seq = raw('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: zero })
    });
    for (var k = merch.length - 1; k >= 0; k--) {
      (function (ln) {
        seq = seq.then(function () {
          var body = { id: ln.variant_id, quantity: ln.quantity };
          if (ln.properties && Object.keys(ln.properties).length) body.properties = ln.properties;
          return raw('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
        });
      })(merch[k]);
    }
    return seq.then(function () { return 'done'; });
  }
  function oneExchange(cart) {
    var items = (cart && cart.items) || [];
    var merch = 0, prot = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.product_id) === PRODUCT_ID) prot.push(it);
      else merch += lineAmount(it);
    }
    if (!items.length || merch <= 0) {
      var rm = {};
      for (var k = 0; k < prot.length; k++) rm[prot[k].key] = 0;
      if (!prot.length) return Promise.resolve('done');
      return raw('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: rm })
      }).then(function () { return 'done'; });
    }
    var want = tierFor(merch).variantId;
    if (!prot.length && AUTO_ADD && !spUserRemoved()) {
      return raw('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: want, quantity: 1 })
      }).then(function () { return 'done'; });
    }
    if (prot.length > 1) {
      var kill = {};
      for (var d = 1; d < prot.length; d++) kill[prot[d].key] = 0;
      return raw('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: kill })
      }).then(function () { return 'done'; });
    }
    // Exact one-shot swap via /cart/update.js: remove old key + add new variant in the
    // same payload. This preserves every other line's position and is a single atomic
    // exchange, so nothing can re-trigger mid-flight.
    var swap = {};
    swap[prot[0].key] = 0;
    swap[String(want)] = 1;
    return raw('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: swap })
    }).then(function () { return 'done'; });
  }
  function nudgeTheme() {
    try { if (typeof window.updateCartCounters === 'function') window.updateCartCounters(); } catch (e) {}
    try { if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') window.Shopify.onCartUpdate(); } catch (e) {}
    try { document.documentElement.dispatchEvent(new CustomEvent('shipping-protection:synced', { bubbles: true })); } catch (e) {}
  }
  function excludedCart(cart) {
    if (!EXCLUDED_PRODUCTS.length) return false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (EXCLUDED_PRODUCTS.indexOf(String(items[i].product_id)) !== -1) return true;
    }
    return false;
  }
  function sync() {
    if (busy || selfMutation || inCool() || inCheckout() || !nativeFetch) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      if (excludedCart(cart)) return false;
      var st = settledState(cart);
      if (st === 'settled') return false;
      if (st === 'reposition') return repositionLast(cart).then(function () { return true; });
      return oneExchange(cart).then(function () { return true; });
    }).then(function (changed) {
      busy = false;
      if (changed) {
        cool(3000);
        nudgeTheme();
        // Post-write re-check: guarantees the follow-up pass (e.g. reposition
        // after a tier add) runs even when the theme emits no cart events.
        setTimeout(function () { try { sync(); } catch (e) {} }, 3300);
        setTimeout(function () { try { sync(); } catch (e) {} }, 6600);
      }
      return changed;
    }).catch(function (err) {
      busy = false;
      if (window.console && console.warn) console.warn('[sp] skipped:', err && err.message);
      return false;
    });
  }
  function schedule() {
    if (busy || selfMutation || inCool() || inCheckout()) return;
    setTimeout(sync, 1200);
  }
  if (window.fetch && nativeFetch) {
    window.fetch = function (input, init) {
      var u = '';
      try { u = String((input && (input.url || input)) || ''); } catch (e) {}
      var isMutation = /\/cart\/(add|update|change|clear)(\.js)?(\?|#|$)/i.test(u);
      var p;
      try { p = nativeFetch.apply(this, arguments); }
      catch (e) { throw e; }
      if (isMutation && !selfMutation) {
        p.then(function () { schedule(); }, function () { schedule(); });
      }
      return p;
    };
  }
  try {
    document.addEventListener('DOMContentLoaded', function () { schedule(); });
    document.addEventListener('cart:updated', function () { schedule(); });
    document.addEventListener('cart:refresh', function () { schedule(); });
    window.addEventListener('pageshow', function () { schedule(); });
  } catch (e) {}

  // ---- respect explicit user deletion of the protection line ----
  var SP_DECLINE = 'sp-protection-declined';
  function spUserRemoved() { try { return sessionStorage.getItem(SP_DECLINE) === '1'; } catch (e) { return false; } }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('a[href*="quantity=0"], a[href*="/cart/change"], cart-remove-button, [data-cart-remove]')) {
      try { sessionStorage.setItem(SP_DECLINE, '1'); } catch (err) {}
      return;
    }
    if (t.closest('form[action*="/cart/add"], [name="add"], .product-form__submit, [data-add-to-cart], [data-quantity-selector]')) {
      try { sessionStorage.removeItem(SP_DECLINE); } catch (err) {}
    }
  }, true);

    window.__spSync = sync;
  setTimeout(sync, 1500);
})();